import { render, staticRenderFns } from "./core.vue?vue&type=template&id=1ea22e3a&scoped=true"
import script from "./core.vue?vue&type=script&lang=js"
export * from "./core.vue?vue&type=script&lang=js"
import style0 from "./core.vue?vue&type=style&index=0&id=1ea22e3a&prod&lang=css"
import style1 from "./core.vue?vue&type=style&index=1&id=1ea22e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea22e3a",
  null
  
)

export default component.exports